import { LessonService } from "@DavisDigital/davisdigitalfrontend.module";
import { Lesson } from "@DavisDigital/interfaces";


class EditLessonDescriptionModalController {
    
    private close:Function; //injected from modal-service

    public lesson:  Lesson;

    public successMessage: string;
    public isLoading = false;
    public isSaveSuccess = false;
	
	// @ngInject
	constructor(
	    private lessonService: LessonService
	){}
	
	
	public onSave = () => {
	 this.isLoading = true;
	    this.lessonService.saveLesson(this.lesson)
        .then( (res) => {
            if( !res?.data?.success){
                throw(res);
            }
            this.isSaveSuccess = true;
            this.successMessage = `Lessson ${this.lesson.title} has been updated successfully`;
        })
        .finally(() => this.isLoading = false);   
	}
	
    private closeModal = () =>{
		this.close( this.isSaveSuccess ? this.lesson : undefined );
	}
    
}

class EditLessonDescriptionModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    lesson: "<",
		close:'='
	};

	public controller = EditLessonDescriptionModalController;
	public controllerAs = 'lessonDescriptionModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/edit-lesson-description-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { EditLessonDescriptionModal };
